<template>
  <div class="pb-2">
    <div class="vx-row">
      <div class="vx-col" style="width: 100%">
        <vx-card
          v-show="video.videoUrl && !video.videoUrl.includes('content.digicampus.co.za')"
          class="overflow-hidden"
          style="width: 65%"
        >
          <template slot="no-body">
            <video id="player" controls />
          </template>
        </vx-card>
        <vx-card
          v-show="video.videoUrl && video.videoUrl.includes('content.digicampus.co.za')"
          class="overflow-hidden"
          style="width: 70%"
        >
          <div class="player" style="max-width: 100% !important;">
            <video class="video-js" style="max-width: 100% !important;" ref="videojs" autoplay controls></video>
          </div>
        </vx-card>
      </div>
    </div>
    <div
      class="flex flex-wrap items-center justify-center mt-3"
      style="width: 100%"
    >
      <vs-textarea
        v-model="comment"
        v-show="$route.query.m && video.videoUrl"
      />
      <vs-button
        v-show="$route.query.m && $route.query.m == 'rev' && video.videoUrl"
        class="vs-con-loading__container mr-4"
        color="success"
        ref="approveButton"
        @click="approve"
        >Approve</vs-button
      >
      <vs-button
        v-show="$route.query.m && $route.query.m == 'rev' && video.videoUrl"
        class="vs-con-loading__container mr-4"
        color="danger"
        ref="rejectButton"
        @click="reject"
        >Reject</vs-button
      >
      <vs-button
        v-show="$route.query.m && $route.query.m == 'rev' && video.videoUrl"
        class="vs-con-loading__container"
        type="border"
        color="warning"
        ref="cancelButton"
        @click="cancel"
        >Cancel</vs-button
      >
    </div>
    <audio
      v-show="music.musicUrl"
      controls
      volume="1"
      :src="musicUrl"
      id="audio"
      class="audio-example pt-8"
      autoplay="true"
    >
      Native audio playback is not supported.
    </audio>
  </div>
</template>

<script>
import Plyr from "plyr";
import "plyr/dist/plyr.css";
import videojs from "video.js";
import streaming from "@videojs/http-streaming";

export default {
  components: {
    Plyr,
    videojs,
    streaming,
  },
  data() {
    return {
      video: {},
      music: {},
      type: "",
      url: "",
      musicUrl: "",
      fileExt: "",
      source: "",
      comment: "",
    };
  },
  methods: {
    previewVideo() {
      var self = this;
      // const player = new Plyr("#player", {
      //   autoplay: true,
      // });


      self.url = self.video.videoUrl;

      if (self.$route.query.m == "rej") self.comment = self.video.comment;
      if (self.url.includes("m3u8")) {
        var searchMask = "/index.m3u8";
        var regEx = new RegExp(searchMask, "ig");
        var replaceMask = ".mp4";
        var hlsPlayer = videojs(self.$refs.videojs);
        hlsPlayer.on("error", function () {
          if (!self.url.includes("stream.digitv.co.za") && (hlsPlayer.error().code == 2 || hlsPlayer.error().code == 4) && !self.url.includes(".mp4")) {
            setTimeout(function () {
              self.url = self.url.replace(regEx, replaceMask);
              hlsPlayer.src({ type: "video/mp4", src: self.url });

              hlsPlayer.play();
            }, 1000);
          } else if (self.url.includes("stream.digitv.co.za") && (hlsPlayer.error().code == 2 || hlsPlayer.error().code == 4)) {
            alert("This live stream is not available at the moment");
            setTimeout(function () {
              hlsPlayer.src({ type: "application/x-mpegURL", src: self.url });
              hlsPlayer.play();
            }, 10000);
          }
        });

        hlsPlayer.src({ type: "application/x-mpegURL", src: self.url });
        hlsPlayer.play();
      } 
      else if (self.video.videoTypeId == 1 || self.video.videoTypeId == 4) {
        var player = videojs(self.$refs.videojs);
          self.videoCompleted = player;
          if (!self.url.toLowerCase().includes(".mp4")){
			      player.on('error', function(err) {  
              if(( player.error().code == 2 || player.error().code == 4) && !self.url.toLowerCase().includes(".mp4")){
                setTimeout(function(){
                  self.url = self.video.url.replace(regEx, replaceMask);
                  player.src({ type: "video/mp4", src: self.url});

                  player.play();
                },1000)
              } 
            });
            
            player.ready(function(){
              this.on("ended", function(){ 
                self.isNextTaskBtnHidden = false;
              });
            });
            player.src({ type: "application/x-mpegURL", src: self.url });
            player.play();
            return;
            
          } else {
            player.ready(function(){
              this.on("ended", function(){ 
                self.isNextTaskBtnHidden = false;
              });
            });
            player.src({ type: "video/mp4", src: self.url });
            player.play();
            return;
          }

        player.play();
      } 
      else if (self.video.videoTypeId == 2) {
        var vimeoVideoId = self.url.substr(self.url.lastIndexOf("/") + 1);
        self.source = [{ src: vimeoVideoId, provider: "vimeo" }];
      } 
      else if (self.video.videoTypeId == 3) {
        // var youtubeVideoId = self.url.substr(self.url.lastIndexOf("/") + 1);
        // self.source = [{ src: youtubeVideoId, provider: "youtube" }];
        var player = videojs(self.$refs.videojs);
        player.src({ type: "youtube", src: this.youtubeVideoId });
        player.play();
        return;
      }
      

      // player.source = {
      //   type: "video",
      //   sources: self.source,
      // };

      


    },
    approve() {
      var self = this;
      self.showLoadingOnElement("approveButton", 0.45, "material");

      var onSuccess = function (response) {
        self.$router.push({ name: "dashboard" });
      };
      self.$ajaxGet(
        self,
        "Video/Approve?id=" + self.video.id + "&comment=" + self.comment,
        onSuccess
      );
    },
    reject() {
      var self = this;
      self.showLoadingOnElement("rejectButton", 0.45, "material");

      var onSuccess = function (response) {
        self.$router.push({ name: "dashboard" });
      };
      self.$ajaxGet(
        self,
        "Video/Reject?id=" + self.video.id + "&comment=" + self.comment,
        onSuccess
      );
    },
    cancel() {
      this.$router.push({ name: "dashboard" });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale,
      });
    },
  },
  created() {
    var videoId = this.$route.query.videoId;
    var musicId = this.$route.query.musicId;
    const self = this;
    if (videoId) {
      var onSuccess = function (response) {
        self.video = response.data;
        self.previewVideo();
      };
      self.$ajaxGet(self, "/Student/Video/GetVideo/" + videoId, onSuccess);
    } else if (musicId) {
      var onSuccess = function (response) {
        self.music = response.data;
        self.musicUrl = self.music.musicUrl;
      };
      self.$ajaxGet(self, "Music/GetMusic/" + musicId, onSuccess);
    }
  },
};
</script>
<style type="stylesheet">
@import "https://unpkg.com/video.js/dist/video-js.min.css";
</style>
<style lang="scss">
</style>
